import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { dishStatuses } from '@/const'
import MainMap from '@/components/main-map/main-map.vue'
import OrderHistoryModal from '@/components/modals/order-history-modal/order-history-modal.vue'
import TextModal from '@/components/modals/text-modal/text-modal.vue'
import IcBicycle from '@/assets/svg/ic_bicycle.svg?inline'
import IcMapPin from '@/assets/svg/ic-map-pin.svg?inline'
import IcPrint from '@/assets/svg/ic-print.svg?inline'
import IcCar from '@/assets/svg/ic-car.svg?inline'
import formatFunctons from '@/components/mixins/format-functions'
import copyTextMixin from '@/components/mixins/copy-text-mixin'
import escPressPagesWithMap from '@/pages/mixins/escPressPagesWithMap'

export default {
  name: 'OrderDetail',
  /**
   * formatFuncton:
   *  getFormatDate
   *  getShortId
   *  getCookedTime
   *
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   *
   * escPressPagesWithMap - переход назад по esc
   */
  mixins: [formatFunctons, copyTextMixin, escPressPagesWithMap],
  components: {
    MainMap,
    OrderHistoryModal,
    TextModal,
    IcBicycle,
    IcMapPin,
    IcPrint,
    IcCar
  },
  static() {
    return {
      dishStatuses
    }
  },
  data() {
    return {
      orderInfo: null,
      fullNote: '',
      orderOptions: {
        ignored: false,
        takeaway: false
      }
    }
  },
  computed: {
    ...mapState({
      paymentTypes: state => state.sharedData.paymentTypes,
      orderStatuses: state => state.sharedData.orderStatuses,
      editedRouteTask: state => state.routeTasks.editedRouteTask,
      loading: state => state.pageLoader.loading,
      sharedTime: state => state.sharedTime.time,
      routeManufactureId: state => state.manufactures.routeManufactureId,
      selectedManufacture: state => state.manufactures.selectedManufacture,
      user: state => state.users.user
    }),
    ...mapGetters({
      isAutoRouteTaskActive: 'logistics/isAutoRouteTaskActive' // Теперь это вычисляемое свойство
    }),
    restTime() {
      const deliveryTo = this.$moment(this.orderInfo.times.delivery_to)
      const diff = deliveryTo.diff(this.$moment(this.sharedTime), 'seconds')
      let minutes = Math.floor(Math.abs(diff) / 60)
      if (diff < 0) {
        minutes = -minutes
      }
      const seconds = Math.abs(diff - minutes * 60)
      return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
    },
    isOrderEditable() {
      const { status = 'delivering' } = this.orderInfo || {}
      const statusOrder = this.orderStatuses[status].order_number
      return statusOrder <= this.orderStatuses.collecting.order_number
    }
  },
  async mounted() {
    if (this.routeManufactureId) {
      this.getOrderDetailInfo()
    } else {
      if (this.user) {
        if (!this.selectedManufacture) {
          this.$router.push({
            name: 'welcome-screen'
          })
        } else {
          /**
           * Производство станет после пользователя в app.js
           */
          this.getOrderDetailInfo()
        }
      }
    }
  },
  beforeDestroy() {
    this.orderInfo = null
  },
  methods: {
    ...mapActions({
      getRouteTaskById: 'routeTasks/getRouteTaskById',
      getOrderDetail: 'orders/getOrderDetail',
      printInvoice: 'orders/printInvoice',
      printStickers: 'orders/printStickers',
      printItemSticker: 'orders/printItemSticker',
      printComboSticker: 'orders/printComboSticker',
      updateOrder: 'orders/updateOrder'
    }),
    ...mapMutations({
      setLoader: 'pageLoader/SET_LOADING',
      setEditedRouteTask: 'routeTasks/SET_EDITED_ROUTE_TASK',
      setRouteManufactureId: 'manufactures/SET_ROUTE_MANUFACTURE_ID'
    }),
    async getOrderDetailInfo() {
      let manufactureId
      /**
       * если есть routeManufactureId - берем его
       */

      if (this.routeManufactureId !== null) {
        manufactureId = this.routeManufactureId
      } else {
        manufactureId = this.selectedManufacture.id
      }
      try {
        this.setLoader(true)
        const res = await this.getOrderDetail({ orderId: this.$route.params.id, manufactureId })
        this.orderInfo = res
      } finally {
        this.setLoader(false)
        this.setRouteManufactureId(null)
      }
    },
    showHistory() {
      this.$refs['order-history-modal'].show()
    },
    getRoutTaskText(order, isShort = false) {
      return `м ${isShort ? this.getShortId(order.route_task_info.id) : order.route_task_info.id}${
        order.route_task_info.allowed_by_foot_courier ? ' (в)' : ''
      }`
    },
    selectRouteTask(event, order) {
      if (this.isShiftPress) {
        this.onCopyText(event, this.getRoutTaskText(order))
        return
      }
      this.getRouteTaskById(order.route_task_info.id)
    },
    getShortNote(note, limitNote = 120) {
      if (!note) {
        return ''
      }
      if (note.length > limitNote) {
        return `${note.slice(0, limitNote - 4)}...`
      }
      return note
    },
    showFullNote(note) {
      this.fullNote = note
      this.$nextTick(() => {
        this.$refs['show-note-modal'].show()
      })
    },
    addOrderRouteTask() {
      /**
       * создаем объект заказа с необходимыми для карты полями
       */
      const orderObjAdd = {
        id: this.orderInfo.order_id,
        status: this.orderInfo.status,
        address: {
          ...this.orderInfo.address_info.address
        },
        times: {
          ...this.orderInfo.times
        }
      }
      this.setEditedRouteTask([orderObjAdd])
    },
    async toggleOrderOption(option) {
      const isToggleable =
        this.orderOptions[option] || Object.values(this.orderOptions).every(o => !o)
      if (this.isOrderEditable && isToggleable) {
        let action = this.orderOptions.takeaway ? 'transfer_to_delivery' : 'transfer_to_takeaway'
        if (option === 'ignored') {
          action = this.orderOptions.ignored ? 'set_not_ignored' : 'set_ignored'
        }
        this.setLoader(true)
        try {
          await this.updateOrder({
            orderId: this.orderInfo.order_id,
            data: {
              action
            }
          })
          this.orderOptions[option] = !this.orderOptions[option]
          this.setLoader(false)
        } catch (e) {
          this.setLoader(false)
          throw e
        }
      }
    }
  },
  watch: {
    orderInfo: {
      immediate: true,
      handler(data) {
        const { ignored = false, takeaway = false } = data || {}
        this.orderOptions.ignored = ignored
        this.orderOptions.takeaway = takeaway
      }
    }
  }
}
